import React from 'react';
import { useLanguage, Language } from '../contexts/LanguageContext';
import './LanguageSwitcher.css';

export const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const languages: { code: Language; name: string }[] = [
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
  ];

  return (
    <div className="language-switcher" data-testid="language-switcher">
      {languages.map((lang) => (
        <button
          key={lang.code}
          data-testid={`language-switcher-${lang.code}`}
          className={`lang-button ${language === lang.code ? 'active' : ''}`}
          onClick={() => setLanguage(lang.code)}
          title={`Switch to ${lang.name}`}
        >
          {lang.code.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
